exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-statusContainer-3M-LT{padding:7px 12px;font-size:14px;position:fixed;z-index:10000;background-color:rgba(0,0,0,.8);border-radius:6px;color:#fff;width:auto;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// Exports
exports.locals = {
	"statusContainer": "style-statusContainer-3M-LT"
};